import React, { useEffect, useMemo, useState } from "react";
import { toggleFavoriteGame } from "../../api/putApi";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { notice } from "../../../src/redux/action/action";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import { getFavoriteGameList } from "../../api/getApi";
import { storeFavoriteGameList } from "../../redux/action/game/gameAction";
import { isLoggedIn } from "../../utils/isLoggedIn";

const ToggleFavorite = () => {
  const { t } = useTranslation();
  const i18n_common = (key) => t(`common.${key}`);
  const dispatch = useDispatch();

  const gameConfig = useSelector((state) => state.isGameConfig);
  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);
  const { favoriteGameList } = isHandleAllGame;

  const { gameUid } = gameConfig;

  const findIsFavorite = useMemo(() => {
    return favoriteGameList?.some((item) => item.gameUid === gameUid);
  }, [gameUid, favoriteGameList]);

  const [isClicking, setIsClicking] = useState(false);
  const [favorite, setFavorite] = useState(findIsFavorite);

  const navigate = useNavigate();

  useEffect(() => {
    if (gameConfig) {
      setFavorite(findIsFavorite);
    }
  }, [gameConfig, findIsFavorite]);

  const handleToggleFavorite = (toggleCode) => {
    if (!isLoggedIn()) {
      navigate("/casino/signin");
      return;
    }
    setIsClicking(true);
    setFavorite(!favorite);
    toggleFavoriteGame({
      gameUid: gameUid,
      params: {
        status: toggleCode,
      },
    })
      .then((data) => {
        getFavoriteGameList().then((data) => {
          dispatch(storeFavoriteGameList(data.userFavoriteGame));
        });
      })
      .catch((err) => {})
      .finally(() => {
        setIsClicking(false);
      });
  };

  return (
    <div>
      {favorite ? (
        <AiFillHeart
          onClick={() => {
            if (isClicking) {
              return;
            }
            handleToggleFavorite(0);
          }}
          className={`${
            isClicking ? "cursor-not-allowed" : "cursor-pointer"
          } text-red-600 hover:text-red-700 text-2xl`}
        />
      ) : (
        <AiOutlineHeart
          onClick={() => {
            if (isClicking) {
              return;
            }
            handleToggleFavorite(1);
          }}
          className={`${
            isClicking ? "cursor-not-allowed" : "cursor-pointer"
          } hover:text-light-orange text-2xl`}
        />
      )}
    </div>
  );
};

export default ToggleFavorite;
